import "./NlpChat.css";
import React, {useEffect, useState} from "react";
import NlpChatInput from "./NlpChatInput/NlpChatInput";

const NlpChat: React.FC = () => {

    return (
        <div className="NlpChat">
            <NlpChatInput></NlpChatInput>
        </div>
    );
};

export default NlpChat;
